import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Editbox from '../../Part_Sample/Editbox';
import Switch from '../../Part_Sample/Switch';
import Icon_Carousel from '../../Part_Sample/Icon_Carousel';

import { getPointIconList } from '../../Common/Common';

import Notification from './Notification';

export default class Edit_Point_Settings extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();
		let point_info = window.app.state.point_list[this.props.param.point_id];
		let selected_icon = 'AC1.png';
		if (point_info.icon != null && point_info.icon != undefined && point_info.icon != '') {
			selected_icon = point_info.icon;
		}

		let icon_list = getPointIconList();
		for (let i in icon_list) {
			if (icon_list[i].key == selected_icon) {
				icon_list[i].is_selected = true;
				break;
			}
		}

		// Range
		//let lower_range = '0';
		//let upper_range = '100';
		// NDP (No. of Decimal Places)
		//let ndp = '0';
		// Unit
		let unit = '';
		// Sub Unit
		let sub_unit = '';
		// Limit
		let limit_valid = false;
		let lower_limit = '';
		let upper_limit = '';
		// Off Delay
		//let off_delay = '0';
		// Temp Limit
		let lower_temp_limit = '';
		let upper_temp_limit = '';
		let temp_limit_valid = false;
		// Notification
		let notify = false;

		if (point_info.type == 'Status') {
			// Status
		} else if (point_info.type == 'Meter') {
			// Meter
			if (point_info.unit != null && point_info.unit != undefined && point_info.unit != '') {
				if (point_info.unit != null) unit = point_info.unit.toString();
			}
			if (point_info.sub_unit != null && point_info.sub_unit != undefined && point_info.sub_unit != '') {
				if (point_info.sub_unit != null) sub_unit = point_info.sub_unit.toString();
			}
		} else if (point_info.type == 'Value' || point_info.type == 'Level' || point_info.type == 'LevelSw') {
			// Value, Level, LevelSw
			if (point_info.limit != null && point_info.limit != undefined && point_info.limit != '') {
				if (point_info.limit[0] != null) lower_limit = point_info.limit[0].toString();
				if (point_info.limit[1] != null) upper_limit = point_info.limit[1].toString();
			}
			if (point_info.unit != null && point_info.unit != undefined && point_info.unit != '') {
				unit = point_info.unit.toString();
			}

			if (point_info.type == 'Value' && point_info.limit_valid != null) {
				limit_valid = point_info.limit_valid;
			}
		} else if (point_info.type == 'Ac') {
			if (point_info.temp_limit != null && point_info.temp_limit != undefined && point_info.temp_limit != '') {
				if (point_info.temp_limit[0] != null) lower_temp_limit = point_info.temp_limit[0].toString();
				if (point_info.temp_limit[1] != null) upper_temp_limit = point_info.temp_limit[1].toString();
				if (point_info.temp_limit_valid != null) temp_limit_valid = point_info.temp_limit_valid;
			}
		}

		//Tommy - 23/02/2021 - Add in Lock, SensorStat, Shutter, Rgbw
		if (['Ac', 'Dehumi', 'Switch', 'Level', 'LevelSw', 'Status', 'Lock', 'SensorStat', 'Shutter', 'Rgbw', 'Hrv', 'Occupied'].includes(point_info.type)) {
			if (point_info.notify != null && point_info.notify != undefined && point_info.notify != '') {
				if (point_info.notify != null) notify = point_info.notify;
			}
		}

		this.state = {
			name: point_info.name,
			icon_list: icon_list,
			//off_delay: off_delay,
			//lower_range: lower_range,
			//upper_range: upper_range,
			//ndp: ndp,
			limit_valid: limit_valid,
			lower_limit: lower_limit,
			upper_limit: upper_limit,
			unit: unit,
			sub_unit: sub_unit,
			lower_temp_limit: lower_temp_limit,
			upper_temp_limit: upper_temp_limit,
			temp_limit_valid: temp_limit_valid,
			notify: notify,
		}
	}

	handlePrevious = () => {
		if (this.props.param.from == 'Operation_Screen') {
			let point_info = window.app.state.point_list[this.props.param.point_id];
			this.props.content_handler(this.props.param.from, { point_id: this.props.param.point_id, point_info: point_info, from: this.props.param.original_from, group_info: this.props.param.group_info, groups: this.props.param.groups });
		} else {
			this.props.content_handler(this.props.param.from, { devices_scroll_top: this.props.param.devices_scroll_top });
		}
	}

	handleChangeName = (val) => {
		this.setState({ name: val })
	}

	handleSelectIcon = (key) => {
		let icon_list = this.state.icon_list;
		for (let i in icon_list) {
			if (icon_list[i].key == key) {
				icon_list[i].is_selected = true;
			} else {
				icon_list[i].is_selected = false;
			}
		}

		this.setState({ icon_list: icon_list })
	}

	handleChangeUnit = (val) => {
		this.setState({ unit: val })
	}

	handleChangeSubUnit = (val) => {
		this.setState({ sub_unit: val })
	}

	handleChangeLowerLimit = (val) => {
		this.setState({ lower_limit: val })
	}

	handleChangeUpperLimit = (val) => {
		this.setState({ upper_limit: val })
	}

	handleToggleTempLimitValid = (val) => {
		this.setState({ temp_limit_valid: !this.state.temp_limit_valid })
	}

	handleToggleLimitValid = (val) => {
		this.setState({ limit_valid: !this.state.limit_valid })
	}

	handleChangeLowerTempLimit = (val) => {
		this.setState({ lower_temp_limit: val })
	}

	handleChangeUpperTempLimit = (val) => {
		this.setState({ upper_temp_limit: val })
	}

	handleChangeNotification = (val) => {
		this.setState({ notify: !this.state.notify })
	}

	handleRegister = () => {
		let tempName = this.state.name.split(/\s/).join('');  //check for names that are just spaces.

		if (tempName == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		let selected_icon = '';
		for (let i in this.state.icon_list) {
			if (this.state.icon_list[i].is_selected) {
				selected_icon = this.state.icon_list[i].key;
				break;
			}
		}

		let point_settings = {};
		point_settings[this.props.param.point_id] = {};
		point_settings[this.props.param.point_id].name = this.state.name;
		point_settings[this.props.param.point_id].icon = selected_icon;

		let point_info = window.app.state.point_list[this.props.param.point_id];
		if (point_info.type == 'Status') {
			// Status
		} else if (point_info.type == 'Meter') {
			// Meter
			point_settings[this.props.param.point_id].unit = this.state.unit;
			point_settings[this.props.param.point_id].sub_unit = this.state.sub_unit;
		} else if (point_info.type == 'Value' || point_info.type == 'Level' || point_info.type == 'LevelSw') {
			// Value, Level, LevelSw
			let upper_limit = this.state.upper_limit;
			if (upper_limit == '') upper_limit = null;
			else upper_limit = parseInt(upper_limit);

			let lower_limit = this.state.lower_limit;
			if (lower_limit == '') lower_limit = null;
			else lower_limit = parseInt(lower_limit);

			if (point_info.type == 'Value') {
				point_settings[this.props.param.point_id].limit_valid = this.state.limit_valid;
			}

			//Added Lower limit/Upper limit Min/Max check
			if(lower_limit != null || upper_limit != null) {
				if(lower_limit >= upper_limit || lower_limit == null) {
					if(point_info.type == 'Value') {
						window.app.showToast(this.props.receiver.getString('lower_upper_error'), 3000);
					} else {
						window.app.showToast(this.props.receiver.getString('min_max_error'), 3000);
					}
					return;
				}
			}

			point_settings[this.props.param.point_id].unit = this.state.unit;
			point_settings[this.props.param.point_id].limit = [lower_limit, upper_limit];
		} else if (point_info.type == 'Ac') {
			// Ac
			let upper_temp_limit = this.state.upper_temp_limit;
			if (upper_temp_limit == '') upper_temp_limit = null;
			else upper_temp_limit = parseInt(upper_temp_limit);

			let lower_temp_limit = this.state.lower_temp_limit;
			if (lower_temp_limit == '') lower_temp_limit = null;
			else lower_temp_limit = parseInt(lower_temp_limit);

			//Added Min/Max check
			if(lower_temp_limit != null || upper_temp_limit != null) {
				if(lower_temp_limit >= upper_temp_limit || lower_temp_limit == null) {
					window.app.showToast(this.props.receiver.getString('min_max_error'), 3000);
					return;
				}
			}

			point_settings[this.props.param.point_id].temp_limit = [lower_temp_limit, upper_temp_limit];
			point_settings[this.props.param.point_id].temp_limit_valid = this.state.temp_limit_valid;
		}

		//Tommy 23/02/2021 - Added in Lock and SensorStat, Shutter, Rgbw
		if (['Ac', 'Dehumi', 'Switch', 'Level', 'LevelSw', 'Status', 'Lock', 'SensorStat', 'Shutter', 'Rgbw', 'Hrv', 'Occupied'].includes(point_info.type)) {
			point_settings[this.props.param.point_id].notify = this.state.notify;
		}

		this.props.receiver.setPointSettings(point_settings);
	}

	rcvSetPointSettings = (response) => {
		if (response.result == 'OK') {
			// Update window.app.state.point_list
			let selected_icon = '';
			for (let i in this.state.icon_list) {
				if (this.state.icon_list[i].is_selected) {
					selected_icon = this.state.icon_list[i].key;
					break;
				}
			}

			let point_list = JSON.parse(JSON.stringify(window.app.state.point_list));
			point_list[this.props.param.point_id].name = this.state.name;
			point_list[this.props.param.point_id].icon = selected_icon;

			let point_info = point_list[this.props.param.point_id];
			if (point_info.type == 'Status') {
				// Status & //SensorStat
			} else if (point_info.type == 'Meter') {
				// Meter
				point_list[this.props.param.point_id].unit = this.state.unit;
				point_list[this.props.param.point_id].sub_unit = this.state.sub_unit;
			} else if (point_info.type == 'Value' || point_info.type == 'Level' || point_info.type == 'LevelSw') {
				// Value Level LevelSw
				let upper_limit = this.state.upper_limit;
				if (upper_limit == '') upper_limit = null;
				else upper_limit = parseInt(upper_limit);

				let lower_limit = this.state.lower_limit;
				if (lower_limit == '') lower_limit = null;
				else lower_limit = parseInt(lower_limit);

				if (point_info.type == 'Value') {
					point_list[this.props.param.point_id].limit_valid = this.state.limit_valid;
				}

				point_list[this.props.param.point_id].unit = this.state.unit;
				point_list[this.props.param.point_id].limit = [lower_limit, upper_limit];
			} else if (point_info.type == 'Ac') {
				// Ac
				let upper_temp_limit = this.state.upper_temp_limit;
				if (upper_temp_limit == '') upper_temp_limit = null;
				else upper_temp_limit = parseInt(upper_temp_limit);

				let lower_temp_limit = this.state.lower_temp_limit;
				if (lower_temp_limit == '') lower_temp_limit = null;
				else lower_temp_limit = parseInt(lower_temp_limit);

				point_list[this.props.param.point_id].temp_limit = [lower_temp_limit, upper_temp_limit];
				point_list[this.props.param.point_id].temp_limit_valid = this.state.temp_limit_valid;
			}

			if (['Ac', 'Dehumi', 'Switch', 'Level', 'LevelSw', 'Status', 'Lock', 'SensorStat', 'Shutter', 'Rgbw', 'Hrv', 'Occupied'].includes(point_info.type)) {
				point_list[this.props.param.point_id].notify = this.state.notify;
			}

			window.app.setState({ point_list: point_list }, () => {
				this.handlePrevious();
			});
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - 55,
			overflow: 'auto'
		}

		let button_style = {
			width: this.props.width - 80,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
		}

		let point_info = window.app.state.point_list[this.props.param.point_id];

		let is_show_unit = false;
		let is_show_sub_unit = false;
		let is_show_limit = false;
		let is_show_temp_limit = false;
		let is_show_notify = false;
		let is_show_limit_valid = false;

		if (point_info.type == 'Status') {
			// is_show_off_delay = true;
		//} else if (point_info.type == 'Meter') {
			//is_show_unit = true;
			//is_show_sub_unit = true;
		} else if (point_info.type == 'Value' || point_info.type == 'Level' || point_info.type == 'LevelSw') {
			is_show_unit = true;
			is_show_limit = true;
		} else if (point_info.type == 'Ac') {
			is_show_temp_limit = true;
		}

		if (['Ac', 'Dehumi', 'Switch', 'Level', 'LevelSw', 'Status', 'Lock', 'SensorStat', 'Shutter', 'Rgbw', 'Hrv', 'Occupied'].includes(point_info.type)) {
			is_show_notify = true;
		}

		if (point_info.type == 'Value') is_show_limit_valid = true;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('edit_device')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20 }}>
						<div style={{ width: this.props.width - 40, marginLeft: 10 }}>
							<Editbox id='point_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeName(event.target.value)} value={this.state.name} />
						</div>
					</div>
					<div style={{ marginTop: 20 }}>
						<Icon_Carousel id={'point_icon_carousel'} width={this.props.width} icon_list={this.state.icon_list} handleSelectIcon={this.handleSelectIcon} />
					</div>
					<div style={{ marginTop: 20, display: is_show_notify ? 'block' : 'none', }}>
						<Notification
							style={{ textAlign: 'left', width: this.props.width - 40, marginLeft: 10, marginTop: 10, marginBottom: 10 }}
							receiver={this.props.receiver}
							point_info={point_info}
							handleChangeNotification={this.handleChangeNotification}
						/>
					</div>
					<div style={{ marginTop: 20, display: is_show_unit ? 'block' : 'none', }}>
						<div style={{ width: this.props.width - 40, marginLeft: 10 }}>
							<Editbox id='unit' style={{}} placeholder={this.props.receiver.getString('unit')} inputType='text' onChange={(event) => this.handleChangeUnit(event.target.value)} value={this.state.unit} />
						</div>
					</div>
					<div style={{ marginTop: 20, display: is_show_sub_unit ? 'block' : 'none', }}>
						<div style={{ width: this.props.width - 40, marginLeft: 10 }}>
							<Editbox id='sub_unit' style={{}} placeholder={this.props.receiver.getString('sub_unit')} inputType='text' onChange={(event) => this.handleChangeSubUnit(event.target.value)} value={this.state.sub_unit} />
						</div>
					</div>
					<div style={{ marginTop: 20, display: is_show_limit ? 'block' : 'none', marginBottom: 20 }}>
						<div style={{ textAlign: 'left', width: this.props.width - 40, marginLeft: 10 }}>
							<div>
								<span className="header">{point_info.type == 'Value' ? this.props.receiver.getString('limit_mon') : this.props.receiver.getString('limit')}</span>
							</div>
						</div>
						<div style={{ textAlign: 'left', width: this.props.width - 40, marginLeft: 10, marginTop: 10, marginBottom: 10 }}>
							<div style={{ display: is_show_limit_valid ? 'inline-block' : 'none', verticalAlign: 'top' }}>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.limit_valid} handleToggleSwitch={this.handleToggleLimitValid} />
							</div>
						</div>
						<div style={{ display: 'inline-block', width: (this.props.width - 40) / 2, marginLeft: 10 }}>
							<Editbox id='lower_limit' style={{}} placeholder={point_info.type == 'Value' ? this.props.receiver.getString('low_lim') : this.props.receiver.getString('min')} inputType='number' onChange={(event) => this.handleChangeLowerLimit(event.target.value)} value={this.state.lower_limit} />
						</div>
						<div style={{ display: 'inline-block', width: (this.props.width - 40) / 2, marginLeft: 10 }}>
							<Editbox id='upper_limit' style={{}} placeholder={point_info.type == 'Value' ? this.props.receiver.getString('up_lim') : this.props.receiver.getString('max')} inputType='number' onChange={(event) => this.handleChangeUpperLimit(event.target.value)} value={this.state.upper_limit} />
						</div>
					</div>
					<div style={{ marginTop: 20, display: is_show_temp_limit ? 'block' : 'none', marginBottom: 20 }}>
						<div style={{ textAlign: 'left', width: this.props.width - 40, marginLeft: 10 }}>
							<div>
								<span className="header">{this.props.receiver.getString('temp_limit')}</span>
							</div>
						</div>
						<div style={{ textAlign: 'left', width: this.props.width - 40, marginLeft: 10, marginTop: 10, marginBottom: 10 }}>
							<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.temp_limit_valid} handleToggleSwitch={this.handleToggleTempLimitValid} />
							</div>
						</div>
						<div style={{ display: 'inline-block', width: (this.props.width - 40) / 2, marginLeft: 10 }}>
							<Editbox id='lower_temp_limit' style={{}} placeholder={this.props.receiver.getString('min')} inputType='number' onChange={(event) => this.handleChangeLowerTempLimit(event.target.value)} value={this.state.lower_temp_limit} />
						</div>
						<div style={{ display: 'inline-block', width: (this.props.width - 40) / 2, marginLeft: 10 }}>
							<Editbox id='upper_temp_limit' style={{}} placeholder={this.props.receiver.getString('max')} inputType='number' onChange={(event) => this.handleChangeUpperTempLimit(event.target.value)} value={this.state.upper_temp_limit} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}